import Helper from './Helper';

class NoHeader {
  constructor() {
    const body = document.querySelector('body');
    this.headerBg = document.querySelector('.ns-img--bg-header');

    if ( this.headerBg == null ) {
      Helper.addClass(body, 'no-header');
    }
  }
}
export default NoHeader;
